(function () {
  function clean(txt) {
    return (txt || "").replace(/\s+/g, " ").trim();
  }

  // ✅ Agora o size vem direto do value do facet (ex: "S", "M", "32")
  function getSelectedSizeFromFacets() {
    const checked = document.querySelectorAll(
      'input[type="checkbox"]:checked, input[type="radio"]:checked'
    );

    for (const input of checked) {
      const name = (input.getAttribute("name") || "").toLowerCase();

      // IMPORTANTE: agora é Variant option -> option.size
      const isSizeFacet = name.includes("filter") && name.includes("option.size");
      if (!isSizeFacet) continue;

      const v = clean(input.value);
      if (v) return v;
    }

    return null;
  }

  function applySizeAvailabilityFilter() {
    const selected = getSelectedSizeFromFacets();
    const cards = document.querySelectorAll("product-card[data-size-availability]");

    // sem size selecionado -> mostra tudo
    if (!selected) {
      cards.forEach((card) => (card.style.display = ""));
      return;
    }

    cards.forEach((card) => {
      const raw = card.getAttribute("data-size-availability") || "{}";
      let map = {};
      try {
        map = JSON.parse(raw);
      } catch (e) {
        map = {};
      }

      // ✅ Queremos APENAS produtos com stock nesse size:
      // se não existir a key, ou for false -> esconde
      if (map[selected] === true) {
        card.style.display = "";
      } else {
        card.style.display = "none";
      }
    });
  }

  // --- Robust AJAX handling (Prestige replaces product-list) ---
  let gridObserver = null;
  let bodyObserver = null;
  let debounceTimer = null;

  function debounceApply(delay) {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      applySizeAvailabilityFilter();
    }, delay);
  }

  function getCurrentGrid() {
    return (
      document.querySelector('[id^="product-list-"]') ||
      document.querySelector("product-list.product-list") ||
      document.querySelector("product-list") ||
      document.querySelector(".product-list")
    );
  }

  function observeGrid(grid) {
    if (!grid) return;

    // se já estamos a observar este grid, não faz nada
    if (gridObserver && gridObserver.__grid === grid) return;

    // limpa observer anterior
    if (gridObserver) gridObserver.disconnect();

    gridObserver = new MutationObserver(() => debounceApply(50));
    gridObserver.__grid = grid;
    gridObserver.observe(grid, { childList: true, subtree: true });

    // aplica logo que apanha o grid novo
    debounceApply(0);
    debounceApply(120);
  }

  function observeBodyForGridReplacement() {
    // observa o body: quando o Prestige trocar o product-list, apanha o novo e reinstala o observer
    if (bodyObserver) bodyObserver.disconnect();

    bodyObserver = new MutationObserver(() => {
      const grid = getCurrentGrid();
      observeGrid(grid);
      debounceApply(80);
    });

    bodyObserver.observe(document.body, { childList: true, subtree: true });
  }

  function hookApplyButtonAndChanges() {
    document.addEventListener("click", (e) => {
      const btn = e.target.closest("button");
      if (!btn) return;

      const txt = clean(btn.textContent).toLowerCase();
      if (txt.includes("apply") || txt.includes("aplicar")) {
        // espera o AJAX render e reaplica
        debounceApply(80);
        debounceApply(250);
        debounceApply(500);
      }
    });

    document.addEventListener("change", (e) => {
      const t = e.target;
      if (t && (t.matches('input[type="checkbox"]') || t.matches('input[type="radio"]'))) {
        debounceApply(80);
        debounceApply(250);
      }
    });
  }

  function hookHistoryChanges() {
    const _pushState = history.pushState;
    const _replaceState = history.replaceState;

    history.pushState = function () {
      _pushState.apply(this, arguments);
      debounceApply(120);
      debounceApply(300);
    };

    history.replaceState = function () {
      _replaceState.apply(this, arguments);
      debounceApply(120);
      debounceApply(300);
    };

    window.addEventListener("popstate", () => {
      debounceApply(120);
      debounceApply(300);
    });
  }

  function boot() {
    // 1) observar body para apanhar quando o grid for trocado
    observeBodyForGridReplacement();

    // 2) observar o grid atual (se já existe)
    observeGrid(getCurrentGrid());

    // 3) hooks
    hookApplyButtonAndChanges();
    hookHistoryChanges();

    // 4) primeira aplicação
    debounceApply(0);
    debounceApply(200);
  }

  document.addEventListener("DOMContentLoaded", boot);
})();